// libs
import styled, { css } from 'styled-components'
// themes
import colors from 'themes/colors'
// static
import CloseIconOrigin from '@mui/icons-material/Cancel'
// utils
import { size } from 'polished'
import { isColorLight } from 'utils/tree'

export const CloseIcon = styled(CloseIconOrigin)<any>`
  path {
    fill: ${colors.white100};
  }

  &:hover {
    path {
      opacity: 0.9;
    }
  }

  min-height: 18px;
  min-width: 18px;
  margin-top: 3px !important;

  ${size('18px')};
`

export const MatrixFieldContainer = styled.div<{
  color: string
  isTable: boolean
  disabled: boolean
  isRiskTemplate: boolean
}>`
  align-items: start;
  background-color: ${({ color }) => color || colors.gray190};
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  display: flex;
  font-size: 14px;
  justify-content: space-between;
  padding: ${({ isRiskTemplate }) => isRiskTemplate ? '12px 12px 12p 0' : '12px'};
  height: fit-content;

  ${({ isTable, color }) =>
    isTable &&
    css`
      height: 100%;
      min-height: 32px;
      padding: 4px 6px;
      align-items: flex-start;
      background-color: ${color || colors.gray230};
      color: ${colors.gray380};

      ${MatrixLabel} {
        font-size: 14px;
      }
    `};

  ${({ color }) =>
    color &&
    css`
      color: ${isColorLight(color) ? colors.black : colors.white};
      font-weight: bold;
    `};
`

export const MatrixLabel = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
`
